import Icon from '../../components/Icon.vue'

Icon.register({
  'brands/osi': {
    width: 495,
    height: 512,
    paths: [
      {
        d: 'M0 259.2C2.3 123.4 97.4 26.8 213.8 11.1 352.6-7.5 469.4 86.9 491.8 212.2 513.1 331 447.8 442.2 340.2 486.2 330.9 490 325.8 487.9 322.2 478.5 304.4 432.2 286.6 385.8 268.8 339.5 265.7 331.4 267.8 326.3 275.8 322.7 300 311.7 315.1 293.3 319.1 266.9 325.5 224.5 294.6 188.2 254.6 184.7 215.6 181.3 182.8 208.4 177.1 244.4 171.9 277.4 188.2 308.1 219 322.1 228.6 326.5 230.5 330.7 226.8 340.5 208.9 387.1 191 433.7 173.1 480.4 170.5 487.3 164.8 489.7 157.6 486.9 105 466.6 56.2 425.9 26.8 367.9 1.9 318.7 1.6 280.2 0 259.2zM20.9 257.3C21.3 263.9 21.5 271.6 22.2 279.4 28.5 351.3 71.8 422.9 153.2 462.5 156.4 464 157.6 463.3 158.8 460.2 173.7 421.1 188.7 382 203.8 342.9 205.1 339.6 204.4 338.1 201.4 336.2 169.8 316.3 154.1 287.7 155.8 250.2 156.8 228.6 165.1 209.7 179.6 193.9 209.6 161.2 256.6 154.1 295.1 176.3 327 194.7 344.6 230.1 340.3 266.7 336.7 297.3 321 320.6 294.6 336.5 291.9 338.1 291.1 339.4 292.3 342.5 307.5 381.7 322.5 420.9 337.5 460.2 338.7 463.3 339.9 464 343.1 462.5 378.6 445.9 408.3 422.2 431.2 390.5 466 342.3 480.3 288.6 473.5 229.5 459.8 112 354.1 14.7 218 31.5 111.9 44.5 22.7 134 20.9 257.3z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/brands/osi.js
// module id = FUgP
// module chunks = 144